











































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import FiltersMixin from "@/mixins/SpecialInitiatives/FiltersMixin";
import VWeekPicker from "@/components/VWeekPicker.vue";
import YearsSelector from "@/components/SpecialInitiatives/YearsSelector.vue";
import VSwitchButton from "@/components/VSwitchButton.vue";
import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import TaxonomySelectV2 from "@/components/TaxonomySelectV2.vue";
import ComparisonGroupSelect from "@/components/ComparisonGroupSelect.vue";
import SpecialInitiatives from "@/services/SpecialInitiavesService";
import {
  Product,
  ProductsCollection,
  ProductsCatalog,
} from "@/models/SpecialInitiatives/Product";
import { Route } from "vue-router";
import HeatmapTable, {
  HeatmapTableColumn,
  HeatmapTableRow,
} from "@/components/HeatmapTable.vue";
import {
  WeekPickerResult,
  WEEK_PICKER_MODALITY_WEEK_RANGE,
} from "@/interfaces/WeekPickerDataTypes";
import SpecialInitiativesChart, {
  ChartWeekRange,
} from "@/components/SpecialInitiatives/Chart.vue";
import SelectOption from "@/interfaces/SelectOption";
import VMultiSwitcher from "@/components/VMultiSwitcher.vue";
import VCheckButton from "@/components/VCheckButton.vue";
import LogoWithFallback from "@/components/LogoWithFallback.vue";
import NumberFormatter from "@/services/NumberFormatter";
import GetColorMixin from "@/mixins/SpecialInitiatives/GetColorMixin";

@Component({
  components: {
    VWeekPicker,
    YearsSelector,
    VSwitchButton,
    MultiLevelSelect,
    TaxonomySelectV2,
    ComparisonGroupSelect,
    HeatmapTable,
    SpecialInitiativesChart,
    VMultiSwitcher,
    VCheckButton,
    LogoWithFallback,
  },
})
export default class SpecialInitiativesClients extends Mixins(
  FiltersMixin,
  GetColorMixin
) {
  private chartTypeItems: Array<SelectOption> = [
    { id: "bar", text: "Barre" },
    { id: "line", text: "Linea" },
    { id: "pie", text: "Torta", disabled: true },
  ];

  chart = {
    settings: {
      stacked: false,
      percentage: false,
      type: "bar",
    },
  };

  compareYearStart = 0;
  compareYearEnd = 0;
  disabled = false;
  loading = false;
  products: ProductsCatalog = {};

  heatmapColumns: HeatmapTableColumn[] = [];
  heatmapRows: HeatmapTableRow[] = [];

  async beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    await this.reload();
    next();
  }

  async reload() {
    this.loading = true;
    if (this.forceReloadFromApi) {
      await this.loadProducts();
      this.forceReloadFromApi = false;
    }
    await this.initData();
    this.loading = false;
  }

  get heatmapSortColumn() {
    if (this.heatmapColumns.length > 0) {
      return this.heatmapColumns[2];
    } else {
      return null;
    }
  }

  get title() {
    const subject = this.clientSubjectsEntries.find(
      (element) => element.id === this.clientSubject
    );
    return `Overview ${subject?.text}`;
  }

  get subjectTaxonomiesHash() {
    return JSON.stringify(this.subjectTaxonomies);
  }

  get currentUnitOfMeasurement(): string {
    if (this.unitOfMeasurement) {
      return (
        this.unitOfMeasurementsEntries.find(
          (e) => e.id === this.unitOfMeasurement
        )?.text || ""
      );
    } else {
      return "";
    }
  }

  get showTaxonomies() {
    return this.clientSubject === "taxonomies";
  }

  get noData(): boolean {
    const keys = Object.keys(this.products);
    let result = true;
    keys.forEach((key) => {
      result =
        result && this.productsFromExclusivity(this.products[key]).length === 0;
    });
    return result;
  }

  canQuery() {
    if (
      !this.filters.clientSubject ||
      this.filters.clientSubject === "taxonomies"
    ) {
      return (
        !!this.filters.subjectSector ||
        !!this.filters.subjectCategory ||
        !!this.filters.subjectClass
      );
    }
    return true;
  }

  compareYearToDisable(): number {
    if (this.filters.weekRange) {
      const yearCompareFilter = this.filters.weekRange.split(",");
      return Number.parseInt(yearCompareFilter[3]);
    }
    return 0;
  }

  weekRangesLabels(): ChartWeekRange[] {
    return Object.keys(this.products).map((weekRange) => {
      return {
        label: this.weekRangeToLabel(weekRange),
        columnName: `col-${weekRange}`,
      };
    });
  }

  async mounted() {
    this.loading = true;
    this.initCompareYearsRange();
    await this.initFilters();
    await this.loadProducts();
    this.initData();
    this.loading = false;
  }

  @Watch("group", { deep: true })
  async onGroupChangedDeep() {
    this.forceReloadFromApi = true;
    await this.reload();
  }

  private initData() {
    this.heatmapColumns = [
      {
        name: "subject",
        label: "Soggetto",
        heatmapDisabled: true,
        locked: true,
      },
      {
        name: "productCount",
        label: "Prodotti",
        small: true,
      },
    ];
    for (const weekRange in this.products) {
      this.heatmapColumns.push({
        name: `col-${weekRange}`,
        label: this.weekRangeToLabel(weekRange),
      });
    }
    this.arrangeDataInTables();
  }

  private arrangeDataInTables() {
    const database: { [key: string]: any } = {};
    for (const weekRange in this.products) {
      const collection = this.products[weekRange];
      const products = this.productsFromExclusivity(collection);
      const total = this.getTotals(products);
      products.forEach((product) => {
        const row = database[product.subjectName] || {
          id: product.subjectId,
          subject: product.subjectName,
          candidates: [product.iconUrl],
          sector: product.sectorName,
          category: product.categoryName,
          class: product.className,
        };
        row.productCount = (row.productCount || 0) + product.productsCount;
        row[`col-${weekRange}`] = this.cellValue(
          total,
          product,
          row[`col-${weekRange}`]
        );
        database[product.subjectName] = row;
      });
    }
    this.heatmapRows = [];
    for (const subject in database) {
      const row: any = {};
      row["id"] = database[subject].id;
      row["subject"] = subject;
      row["sector"] = database[subject].sector;
      row["category"] = database[subject].category;
      row["class"] = database[subject].class;
      row["candidates"] = database[subject].candidates;
      this.heatmapColumns.forEach((column) => {
        row[column.name] =
          database[subject][column.name] || this.cellZeroValue();
      });
      this.heatmapRows.push(row);
    }
  }

  private cellValue(
    total: number,
    product: Product,
    currentCellValue?: number | { type: string; value: number; quote: string }
  ) {
    let cellValue = product[this.columnFromUnitOfMeasurement()];
    if (currentCellValue) {
      if (!isNaN(currentCellValue as any)) {
        cellValue += currentCellValue as number;
      } else {
        cellValue += (
          currentCellValue as { type: string; value: number; quote: string }
        ).value;
      }
    }

    if (
      this.unitOfMeasurement == "quoted_seconds" ||
      this.unitOfMeasurement == "quoted_spots"
    ) {
      return {
        type: "quoted",
        value: cellValue,
        quote: this.cellQuoteFromTotal(total, cellValue),
      };
    }
    return cellValue;
  }

  private cellQuoteFromTotal(total: number, cellValue: number) {
    return `${NumberFormatter.format(cellValue)} (${Number(
      (cellValue / total) * 100
    ).toFixed(0)}%)`;
  }

  private cellZeroValue() {
    if (
      this.unitOfMeasurement == "quoted_seconds" ||
      this.unitOfMeasurement == "quoted_spots"
    ) {
      return {
        type: "quoted",
        value: 0,
        quote: 0,
      };
    }
    return 0;
  }

  private columnFromUnitOfMeasurement() {
    if (
      this.unitOfMeasurement === "seconds" ||
      this.unitOfMeasurement === "quoted_seconds"
    ) {
      return "secondsCount";
    } else if (
      this.unitOfMeasurement === "spots" ||
      this.unitOfMeasurement === "quoted_spots"
    ) {
      return "detectionsCount";
    } else {
      return "companiesCount";
    }
  }

  private getTotals(broadcasters: Product[]) {
    const fieldName = this.columnFromUnitOfMeasurement();
    return broadcasters.reduce((acc, broadcaster) => {
      return acc + broadcaster[fieldName];
    }, 0);
  }

  private productsFromExclusivity(broadcasters: ProductsCollection) {
    if (this.exclusivity === "all") {
      return broadcasters.productsAll;
    } else if (this.exclusivity === "my_exclusivity_type") {
      return broadcasters.productsMine;
    } else if (this.exclusivity === "others_exclusivity_type") {
      return broadcasters.productsOthers;
    } else if (this.exclusivity === "shared_exclusivity_type") {
      return broadcasters.productsShared;
    } else {
      return [];
    }
  }

  private weekRangeToLabel(weekRange: string) {
    if (weekRange) {
      const [w1, y1, w2, y2] = weekRange.split(",");
      const weekPickerRange: WeekPickerResult = {
        type: WEEK_PICKER_MODALITY_WEEK_RANGE,
        start: {
          week: Number.parseInt(w1),
          year: Number.parseInt(y1),
        },
        end: {
          week: Number.parseInt(w2),
          year: Number.parseInt(y2),
        },
      };
      return `Settimane ${VWeekPicker.resultToHumanReadable(weekPickerRange)}`;
    }
    return "";
  }

  async loadProductsFromApi(weekRange: string) {
    const filter = this.filtersForAPI("client");
    filter.weekRange = weekRange;
    const productsAll = await SpecialInitiatives.getProducts(filter);

    this.products[weekRange] = productsAll.reduce(
      (acc, product) => {
        switch (product.exclusivityType) {
          case "mine":
            acc.productsMine.push(product);
            break;
          case "others":
            acc.productsOthers.push(product);
            break;
          case "shared":
            acc.productsShared.push(product);
            break;
        }
        return acc;
      },
      {
        productsAll,
        productsMine: [] as Product[],
        productsOthers: [] as Product[],
        productsShared: [] as Product[],
      }
    );
  }

  async loadProducts() {
    this.loading = true;
    this.products = {};
    const filter = this.filtersForAPI("client");
    if (filter.weekRange && this.canQuery()) {
      await this.loadProductsFromApi(filter.weekRange);
      if (this.yearsToCompare && this.yearsToCompare.length > 0) {
        const weekRanges = this.compareYearsToWeekRanges();
        for (const weekRange of weekRanges) {
          await this.loadProductsFromApi(weekRange);
        }
      }
    }
    this.loading = false;
  }

  private compareYearsToWeekRanges(): string[] {
    const filter = this.filtersForAPI("client");
    const weekRanges: string[] = [];
    if (
      filter.weekRange &&
      this.yearsToCompare &&
      this.yearsToCompare.length > 0
    ) {
      const [w1, y1, w2, y2] = filter.weekRange.split(",");
      const baseYearEnd = Number.parseInt(y2);
      const baseYearStart = Number.parseInt(y1);
      const years = [...this.yearsToCompare];
      for (const year of years.reverse()) {
        const cmpYear = Number.parseInt(year);
        const compareResult = cmpYear - baseYearEnd;
        if (compareResult != 0) {
          const compareWeekRange = [
            w1,
            `${baseYearStart + compareResult}`,
            w2,
            `${baseYearStart + compareResult}`,
          ];
          weekRanges.push(compareWeekRange.join(","));
        }
      }
    }
    return weekRanges;
  }

  private initCompareYearsRange() {
    this.compareYearStart = this.$moment().year();
    this.compareYearEnd = this.compareYearStart - this.compareYearsRange;
  }

  private onClientClicked(value: any) {
    this.$router.push({
      name: "SpecialInitiativesCompany",
      params: { companyId: value.id },
      query: this.queryRefinementForDetail(),
    });
  }

  private queryRefinementForDetail() {
    const query = Object.assign({}, this.$route.query);
    delete query.clientSubject;
    delete query.group;
    delete query.subjectSector;
    delete query.subjectClass;
    delete query.subjectCategory;
    delete query.area;
    return query;
  }
}
